"use client";
import { useEffect } from "react";

function ScrollToTopClient({ scrollToTop }: { scrollToTop: boolean }) {
  useEffect(() => {
    if (scrollToTop) {
      window.scrollTo(0, 0);
    }
  }, [scrollToTop]);

  return null;
}

export default ScrollToTopClient;
